import  React from 'react';
import ProjectImg from '../Assets/williams(Nest Hub Max).png';
import { ReactComponent as Expand } from '../Assets/Full_alt.svg';
import { Link } from 'react-router-dom';


export default function ProjectItem({
  img = ProjectImg,
  title = 'Project Name',
  introdesc = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
  desc = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
  imgAlt = 'Project image Preview',
  imgViewMore = 'View more',
  viewDemo = '',
  id
}) {

  return (
   <div>
      <div className="group relative cursor-pointer" >
        <div className="w-full min-h-80 aspect-w-1 aspect-h-1 rounded-md overflow-hidden group-hover:opacity-50 lg:aspect-none">
             <img src={img}
             alt={imgAlt}
             className="w-full h-full object-center object-cover "
             />
           </div>

              <Link className='absolute  z-50 top-2 right-2' to={`/projects/${title}`}>
                <Expand className=''/>
              </Link>

           <div className="mt-4 bg-gray-900 p-3 rounded-md">
                <div>
                  <h3 className="text-sm text-gray-100 ">
                    <div className="capitalize ">
                      <span className="absolute inset-0 " />
                        {title}
                    </div>
                  </h3>
                </div>
                <p className="text-sm font-medium text-gray-500">{introdesc}</p>
              </div>
           </div>
     </div>
   
  );
}